import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { AuthenticationService } from '@app/shared/services/authentication.service';
import { UserAuthority } from '@app/domain/model/user-authority';

@Directive({
  selector: '[appHasAuthority], [appHasAnyAuthority], [appHasNoAuthority]'
})
export class RequireAuthorityDirective implements OnInit {

  private authorities: UserAuthority[];
  private allowAuthorize = true;

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private readonly authenticator: AuthenticationService) {
  }

  @Input('appHasAuthority') set hasAuthority(authority: string) {
    this.authorities = [UserAuthority.fromString(authority)];
  }

  @Input('appHasAnyAuthority') set hasAnyAuthority(authorities: string[]) {
    this.authorities = authorities.map(authority => UserAuthority.fromString(authority));
  }

  @Input('appHasNoAuthority') set hasNoAuthority(authority: string) {
    this.authorities = [UserAuthority.fromString(authority)];
    this.allowAuthorize = false;
  }

  ngOnInit() {
    const user = this.authenticator.getCurrentUser();
    const authorized = user.hasAnyOfAuthorities(this.authorities);
    if (authorized === this.allowAuthorize) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
